import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundbushirerentalservice() {



  const cardData =
  {
    keyword: 'Daund Bus Hire Rental Service',
    heading: 'Sanavi Travels: Daund Bus Hire Rental Service',
    headingDescription: 'Sanavi Travels offers reliable Daund Bus Hire Rental Service, providing safe, comfortable, and convenient transportation for families, groups, corporate trips, school excursions, and pilgrimage travel. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures ample seating, smooth rides, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip bus hire packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for local travel, outstation trips, corporate events, and group tours. Choose Sanavi Travels for trusted bus hire and rental services in Daund, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird watchers, especially during the migratory season. Visitors can spot flamingos, pelicans, storks, and other waterbirds. Early morning boat rides offer the best viewing experience."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam, situated close to Daund, provide a peaceful setting for picnics, photography, and birdwatching. The expansive water body and surrounding greenery make it an ideal spot for relaxation."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is a significant religious site in Daund, dedicated to Lord Shiva. Devotees visit throughout the year for rituals, prayers, and festivals, enjoying the temple's serene spiritual atmosphere."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is an important transport hub connecting Pune, Solapur, and southern India. The junction facilitates travel and trade, making it vital to the region’s connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands near Bhigwan, close to Daund, are home to diverse bird species and rich biodiversity. Nature enthusiasts and photographers often explore this area for its wildlife and scenic landscapes."
  },
  {
    "title": "Local Sugarcane Fields",
    "description": "Daund is surrounded by fertile agricultural lands, particularly sugarcane plantations. Visitors can witness traditional farming practices and the rural lifestyle of Maharashtra."
  },
  {
    "title": "Village Temples and Wadis",
    "description": "The villages around Daund have several small temples and wadi shrines reflecting traditional religious practices. These sites are often centers for local festivals and community gatherings."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The scenic countryside along Indapur Road features farmland, canals, and open fields. It is ideal for relaxed drives, photography, and experiencing rural Maharashtra."
  },
  {
    "title": "Weekly Local Markets",
    "description": "Daund’s weekly markets are lively spaces where locals sell fresh produce, grains, livestock, and handicrafts. Visitors can experience the vibrancy of rural commerce and community life."
  },
  {
    "title": "Pilgrimage Transit Point",
    "description": "Daund is strategically located near religious destinations like Pandharpur and Bhigwan, making it a convenient stop for pilgrims traveling to temples and spiritual sites."
  }
]
,



"services": [
    {
      "name": "Daund Bus Hire Rental Service",
      "description": "Daund Bus Hire Rental Service provides comprehensive bus rental solutions for every kind of journey. From local sightseeing and family outings to corporate trips and weddings, we offer well-maintained buses with professional drivers, ensuring safety, comfort, and punctuality. Our service emphasizes reliability and flexibility, catering to individual, group, and corporate travel needs, making every journey smooth and memorable."
    },
    {
      "name": "Bus Hire Service Daund",
      "description": "Bus Hire Service in Daund offers a wide range of buses for daily, weekend, and outstation trips. Whether for personal, family, or group travel, our buses are equipped with modern amenities, spacious seating, and experienced chauffeurs. We provide customized itineraries, affordable pricing, and prompt service, making us the preferred choice for reliable and convenient travel in and around Daund."
    },
    {
      "name": "AC Bus Hire Daund",
      "description": "AC Bus Hire in Daund ensures a comfortable and refreshing journey, ideal for long-distance travel, family outings, corporate tours, and tourist trips. Our air-conditioned buses are maintained to the highest standards, providing a relaxing and enjoyable travel experience. Safety, punctuality, and professional drivers make every trip stress-free and convenient for passengers."
    },
    {
      "name": "Luxury Bus Hire Daund",
      "description": "Luxury Bus Hire in Daund offers premium buses for high-end travel experiences. Equipped with plush seating, entertainment options, air conditioning, and professional chauffeurs, these buses are perfect for weddings, VIP events, corporate travel, and exclusive group tours. Our focus is on combining comfort, style, and safety for a seamless and memorable journey."
    },
    {
      "name": "Wedding Bus Hire Daund",
      "description": "Wedding Bus Hire in Daund specializes in providing transportation for weddings, receptions, and related events. Our buses are spacious, comfortable, and punctual, ensuring guests travel with ease and style. We offer flexible itineraries, professional drivers, and a premium fleet that caters to large groups, family members, and bridal parties, making wedding travel stress-free and enjoyable."
    },
    {
      "name": "Corporate Bus Hire Daund",
      "description": "Corporate Bus Hire in Daund offers professional transportation for companies, IT offices, and business events. We provide well-maintained buses with experienced drivers, ensuring punctual and comfortable commutes for employees, corporate outings, seminars, and conferences. Our services are flexible, affordable, and designed to meet the unique travel needs of corporate clients."
    },
    {
      "name": "Outstation Bus Hire Daund",
      "description": "Outstation Bus Hire from Daund provides long-distance travel solutions across Maharashtra and neighboring states. Our buses are ideal for family trips, religious tours, tourist excursions, and corporate travel. We focus on safety, comfort, and on-time performance, offering experienced drivers, AC and non-AC options, and flexible schedules to meet diverse travel requirements."
    },
    {
      "name": "Affordable Bus Hire Daund",
      "description": "Affordable Bus Hire in Daund combines quality, safety, and comfort with budget-friendly pricing. We offer a range of buses suitable for weddings, corporate events, family trips, and group tours without compromising on service quality. Our competitive rates, professional drivers, and well-maintained buses make us the ideal choice for cost-effective transportation."
    },
    {
      "name": "Chauffeur Driven Bus Daund",
      "description": "Chauffeur Driven Bus service in Daund provides a completely stress-free travel experience. Our professional drivers handle navigation, traffic, and schedules, allowing passengers to relax during their journey. Perfect for corporate trips, weddings, tourist excursions, and family travel, our service emphasizes safety, comfort, punctuality, and a high-quality travel experience."
    },
    {
      "name": "Best Bus Hire Daund",
      "description": "Best Bus Hire in Daund guarantees premium-quality buses, punctual service, and professional drivers for all types of travel. From corporate outings to weddings, tourist trips, and group tours, our focus is on delivering a reliable, safe, and enjoyable journey every time. We maintain a diverse fleet and offer flexible options to suit the specific needs of every customer."
    },
    {
      "name": "Tourist Bus Hire Daund",
      "description": "Tourist Bus Hire in Daund specializes in travel for sightseeing, hill stations, and popular attractions. Our buses are comfortable, safe, and equipped for long journeys, making them perfect for families, friends, and tour groups. We provide flexible itineraries, experienced chauffeurs, and a focus on passenger convenience to ensure an enjoyable travel experience."
    },
    {
      "name": "Group Travel Bus Daund",
      "description": "Group Travel Bus in Daund offers organized and efficient transportation for family outings, friends, corporate teams, and social gatherings. Our buses provide spacious seating, comfort, and safety, with professional drivers ensuring timely arrivals and hassle-free travel. We cater to groups of all sizes with flexible routes, schedules, and amenities for a seamless experience."
    },
    {
      "name": "Online Bus Booking Daund",
      "description": "Online Bus Booking in Daund allows passengers to reserve buses easily and securely through a digital platform. Offering instant confirmation, multiple bus options, and flexible scheduling, this service simplifies planning for weddings, corporate events, tourist trips, and long-distance travel. Users can browse, compare, and book buses from anywhere, saving time and ensuring convenience."
    },
    {
      "name": "Event Bus Hire Daund",
      "description": "Event Bus Hire in Daund provides dedicated transportation for weddings, parties, corporate functions, conferences, and other special events. Our buses are spacious, comfortable, and driven by experienced chauffeurs, ensuring smooth and timely travel. We offer customizable itineraries, safety measures, and premium service to make event transportation effortless and reliable."
    },
    {
      "name": "Daund Travel Bus",
      "description": "Daund Travel Bus offers reliable, comfortable, and versatile travel solutions for local trips, outstation journeys, weddings, corporate travel, and group tours. With a focus on safety, punctuality, and passenger satisfaction, we provide a well-maintained fleet, professional drivers, and flexible schedules. Whether for sightseeing, family outings, or business purposes, we ensure a smooth and memorable travel experience."
    }
  ],
  "tableData": [
    ["Daund Bus Hire Rental Service", "Bus Hire Service Daund"],
    ["AC Bus Hire Daund", "Luxury Bus Hire Daund"],
    ["Wedding Bus Hire Daund", "Corporate Bus Hire Daund"],
    ["Outstation Bus Hire Daund", "Affordable Bus Hire Daund"],
    ["Chauffeur Driven Bus Daund", "Best Bus Hire Daund"],
    ["Tourist Bus Hire Daund", "Group Travel Bus Daund"],
    ["Online Bus Booking Daund", "Event Bus Hire Daund"],
    ["Daund Travel Bus", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Daund Bus Hire Rental Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and convenient bus hire rental services in Daund, ideal for family trips, corporate events, school outings, local tours, and intercity travel."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Buses",
    "WhyChoosedescription": "Choose from clean, air-conditioned, and regularly serviced buses, ensuring a comfortable and smooth journey for all types of travel in Daund."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Daund and nearby routes, guaranteeing safe and timely transportation for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for all Daund bus hire services, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "We provide hourly, half-day, full-day, and customized bus hire packages to suit your specific requirements in Daund."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Sanavi Travels guarantees punctual pickups and dependable service, making us a trusted choice for bus hire in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire rental services in Daund?',
    answer: 'Yes, Sanavi Travels offers dependable bus hire rental services in Daund for group travel, corporate events, school outings, and intercity trips.'
  },
  {
    question: 'How can I book a bus hire in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for hire in Daund?',
    answer: 'Sanavi Travels provides mini buses, 20-seater, 32-seater, 35-seater, 45-seater, and 50-seater buses depending on your group size and travel needs.'
  },
  {
    question: 'Are the buses well-maintained and air-conditioned?',
    answer: 'Yes, all buses are clean, air-conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are the drivers experienced with local and intercity routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with both local Daund routes and intercity travel paths.'
  },
  {
    question: 'Can I hire a bus for a few hours or a full day?',
    answer: 'Absolutely. We offer flexible hourly, half-day, full-day, and customized bus hire packages to meet your travel requirements.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before departure to ensure passenger safety.'
  },
  {
    question: 'What payment options are available for Daund bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the bus hire journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your bus hire trip in Daund.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Patil',
    feedback: 'Rented a bus in Daund for our corporate outing. Excellent service, punctual driver, and comfortable bus.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Great experience with the Daund bus hire rental service. Professional staff and smooth journey.',
    rating: 5
  }
];
































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund Bus Hire Rental Service - Sanavi Travels",
  "description": "Sanavi Travels provides Daund bus hire rental services including AC and luxury buses. Ideal for weddings, corporate trips, outstation journeys, tourist travel, group travel, and events. Affordable and chauffeur-driven buses with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "75"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Daund Bus Hire Rental Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides Daund bus hire rental services including AC and luxury buses. Ideal for weddings, corporate trips, outstation journeys, tourist travel, group travel, and events. Affordable and chauffeur-driven buses with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/119.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundbushirerentalservice;